/* eslint-disable react-hooks/exhaustive-deps */
import { useSnackbar } from 'notistack';
import { useCallback, useEffect, useState } from 'react';

export type FetchCallback<T> = (args?: any) => Promise<T>;

export interface FetchOptions {
  defaultMessage?: string;
  ignoreFirstCall?: boolean;
}

export function useFetch<Response>(
  fetchCallback?: FetchCallback<Response>,
  { defaultMessage = 'Não foi possível carregar este recurso agora', ignoreFirstCall = false }: FetchOptions = {}
) {
  const { enqueueSnackbar } = useSnackbar();
  const [result, setResult] = useState<Response>();
  const [loading, setLoading] = useState(false);

  const fetch = useCallback((args?: unknown) => {
    if (fetchCallback) {
      setLoading(true);
      return fetchCallback(args)
        .then(setResult)
        .catch((err) => {
          console.error(err);
          enqueueSnackbar(defaultMessage, { variant: 'error' });
        })
        .finally(() => setLoading(false));
    }

    return undefined;
  }, []);

  useEffect(() => {
    if (!ignoreFirstCall) {
      fetch();
    }

    return () => {
      setResult(undefined);
      setLoading(false);
    };
  }, []);

  return { data: result, refetch: fetch, loading };
}
